import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Portfolio.css";
import { useState, useEffect } from "react";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { CommentsSection } from "./components/CommentsSection";
import { Footer } from "./components/Footer";
import { VisitorTracker } from "./components/VisitorTracker";
import { AdminConsole } from "./components/AdminConsole";
import { AdminLogin } from "./components/AdminLogin";

function App() {
  // Check if admin mode is enabled via URL parameter
  const isAdminMode = window.location.search.includes("admin=true");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if already authenticated in this session
    if (isAdminMode) {
      const authStatus = sessionStorage.getItem("adminAuth");
      setIsAuthenticated(authStatus === "true");
    }
  }, [isAdminMode]);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  return (
    <div className="App">
      <VisitorTracker />
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <NavBar />
      <main id="main-content">
        <Banner />
        <Projects />
        <Skills />
        <Contact />
        <div className="guestbook-wrap page-shell">
          <details className="guestbook-disclosure">
            <summary>
              Leave a note in the guestbook <span aria-hidden="true">+</span>
            </summary>
            <CommentsSection />
          </details>
        </div>
      </main>
      {isAdminMode && !isAuthenticated && (
        <AdminLogin onLoginSuccess={handleLoginSuccess} />
      )}
      {isAdminMode && isAuthenticated && <AdminConsole />}
      <Footer />
    </div>
  );
}

export default App;
